import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import deTranslations from "./locales/de.json";
import enTranslations from "./locales/en.json";

const getLanguageFromPath = () => {
  if (typeof window === "undefined") {
    return "de";
  }
  const pathname = window.location.pathname;
  const pathSegments = pathname.split("/").filter(Boolean);
  const firstSegment = pathSegments[0];

  if (firstSegment === "en") {
    return "en";
  }

  return "de";
};

const language = getLanguageFromPath();

i18n.use(initReactI18next).init({
  lng: language,
  fallbackLng: "de",
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      translation: enTranslations,
    },
    de: {
      translation: deTranslations,
    },
  },
});

export default i18n;
